import React, { Component } from "react";
import DashSearchHeader from "../../part/header.search.dashboard";
import DashMenu from "../../part/dash_menu";
import FooterDashboard from "../../part/footer.dashboard";
import Policy from "../../part/policy";
import { FaArrowLeft } from "react-icons/fa6";
import axios from "axios";
import LoadingError from "../../part/loading_error";
import { Link } from "react-router-dom";



class ExamScore extends Component {
    state = {
        menuCoverWidth: this.getInitialMenuCoverWidth(),
        displayScore: 0,
        targetScore: null, // Change this to any number you want
        correct_answers: 0,
        total_questions: 0,
        exam_title: "",
        loading: false,
        showContactMessage: false
    };

    getInitialMenuCoverWidth() {
        const windowWidth = window.innerWidth;
        if (windowWidth < 900) return 0;
        if (windowWidth >= 900 && windowWidth < 1200) return 60;
        return 260;
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);

        this.fetchScore()
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        if (this.animationInterval) clearInterval(this.animationInterval);
    }



    fetchScore = async () => {
        this.setState({ loading: true })
        const accessToken = localStorage.getItem("accessToken");
        const id = this.props.id
        try {
            const response = await axios.get(`https://api.geoinfoacademy.com/api/student/submissions/result/${id}/`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            this.setState({
                targetScore: response.data.score,
                correct_answers: response.data.correct_answers,
                total_questions: response.data.total_questions,
                exam_title: response.data.exam_title,
                loading: false
            });
            setTimeout(() => { this.animateScore(); }, 1000); // 1s delay
            console.log("API Response:", response.data);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                console.warn("401 Unauthorized error detected. Clearing local storage and redirecting.");
                localStorage.removeItem("accessToken");
                localStorage.removeItem("user");
                window.location.href = "/";
            } else {
                console.error("Error fetching data:", error);
            }
            this.setState({ loading: false })
        }
    }









    handleResize = () => {
        const menuCover = document.querySelector('.dashboard .menu_cover');
        if (menuCover) {
            this.setState({ menuCoverWidth: menuCover.offsetWidth });
        }
    };

    // --- Color Blending Logic ---
    interpolateColor = (color1, color2, factor) => {
        const result = color1.map((c, i) => Math.round(c + factor * (color2[i] - c)));
        return `rgb(${result[0]}, ${result[1]}, ${result[2]})`;
    };

    getSmoothColor = (score) => {
        const points = [
            { score: 0, rgb: [255, 77, 77] },   // Red
            { score: 45, rgb: [241, 196, 15] },  // Gold
            { score: 60, rgb: [85, 239, 196] },  // Light Green
            { score: 80, rgb: [0, 184, 148] },   // Green
            { score: 100, rgb: [0, 107, 83] }     // Deep Green
        ];

        for (let i = 0; i < points.length - 1; i++) {
            const start = points[i];
            const end = points[i + 1];
            if (score >= start.score && score <= end.score) {
                const range = end.score - start.score;
                const factor = (score - start.score) / range;
                return this.interpolateColor(start.rgb, end.rgb, factor);
            }
        }
        return `rgb(0, 107, 83)`;
    };

    animateScore = () => {
        this.animationInterval = setInterval(() => {
            this.setState((prevState) => {
                if (prevState.displayScore < this.state.targetScore) {
                    const nextScore = Math.min(prevState.displayScore + 0.5, this.state.targetScore);
                    return { displayScore: nextScore };
                } else {
                    clearInterval(this.animationInterval);
                    return null;
                }
            });
        }, 15);
    };


    handleRetakeClick = () => {
        this.setState({ showContactMessage: true });
        setTimeout(() => {
            window.location.href = "/dash_contact";
        }, 5000);
    };

    render() {
        const { menuCoverWidth, displayScore, correct_answers, total_questions, exam_title, loading } = this.state;
        const currentColor = this.getSmoothColor(displayScore);
        const degrees = displayScore * 3.6;

        console.log(this.props.id)

        if (loading) {
            return (
                <>
                    <LoadingError />
                </>
            )
        }

        return (

            <div className="dashboard">
                <DashSearchHeader onResize={this.handleResize} />
                <DashMenu />
                <div className="dash_body" style={{ width: `calc(100% - ${menuCoverWidth}px - 10px)`, overflow: `hidden` }}>
                    <div className="exam_score_coverage">
                        <div className="exam_score_cover">
                            <div className="exam_score_contain">

                                <div className="score_button">
                                    <Link to={`/description/${this.props.courseid}/${this.props.course_name}`}><button className="blue"><FaArrowLeft /> Back To Course </button></Link>
                                </div>

                                <h2>Exam Completed : {exam_title} </h2>

                                <div className="score_tracker_cover">
                                    <div className="tracker_contain" style={{ background: `conic-gradient(${currentColor} ${degrees}deg, #eef2f3 ${degrees}deg)` }}>
                                        <div className="tracker_white">
                                            <h5 style={{ color: currentColor }}>
                                                {Math.floor(displayScore)}%
                                            </h5>
                                        </div>
                                    </div>

                                    <div className="track_status" style={{ background: currentColor }}>
                                        <h6>{displayScore > 40 ? "PASSED" : "FAIL"}</h6>
                                    </div>


                                </div>

                                <div className="statement_score_cover">
                                    <h3>Score Details</h3>
                                    <div className="statement_score_contain">

                                        <div className="score_coverage">
                                            <h4>
                                                Correct Score
                                                <span>{correct_answers}</span>
                                            </h4>
                                        </div>

                                        <div className="score_coverage">
                                            <h4>
                                                Total Score
                                                <span>{total_questions}</span>
                                            </h4>
                                        </div>

                                        <div className="score_coverage">
                                            <h4>
                                                Pass Mark
                                                <span>40%</span>
                                            </h4>
                                        </div>

                                    </div>

                                </div>


                                <div className="score_button">
                                    <Link to={`/description/${this.props.courseid}/${this.props.course_name}`}><button className="blue">Take Next Exam</button></Link>
                                    <button onClick={this.handleRetakeClick}>Retake Exam </button>
                                </div>

                                {this.state.showContactMessage && (
                                        <p style={{textAlign:"center", color: "red",fontWeight: "600", fontSize: "17px" }}>Please contact admin... Redirecting to contact page in 5 sec.</p>
                                )}

                            </div>
                        </div>
                    </div>
                    <FooterDashboard />
                    <Policy />
                </div>
            </div>

        )
    }
}


export default ExamScore